module.exports = __webpack_public_path__ + "static/media/CAM-01 fix edit.7d75f9b5.webp";